var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',[_c('v-autocomplete',{attrs:{"label":"Serviços","multiple":"","items":_vm.servicos,"item-text":"descricao","return-object":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }